import React from "react";
import EventCard from "../../VibehutUI/Card/EventCard";
function UpComingEvents({
  events,
  isHomeEvent,
  isShowTitle = true,
  showRoomLink = true,
  isEventPage = false,
}) {
  return (
    events?.length > 0 && (
      <div>
        {isShowTitle && (
          <div className="flex items-center space-x-3">
            <p className="font-bold text-lg text-navyGray dark:text-frescoWhite">
              Upcoming Events
            </p>
          </div>
        )}
        {isEventPage ? (
          <div className="w-full grid md:grid-cols-2 lg:grid-cols-2 3xl:grid-cols-3 grid-cols-1  gap-6 py-6 px-2">
            {events.map((event, index) => (
              <EventCard
                event={event}
                key={index}
                showRoomLink
                enableTopMargin={false}
              />
            ))}
          </div>
        ) : (
          <div className="pt-1 w-full flex flex-col space-y-2 max-w-md">
            {events?.map((event) => (
              <div className="mt-2">
                <EventCard
                  isHomeEvent={isHomeEvent}
                  event={event}
                  showRoomLink={showRoomLink}
                  showCopyIcon
                />{" "}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  );
}

export default UpComingEvents;
